export const terms = {
  "header": {
    "badge": "Información legal",
    "title": "Condiciones de uso"
  },
  "content": {
    "intro": "Bienvenido a VIAJES EN BURRO. Estas condiciones de uso regulan el acceso y uso de nuestra plataforma de intercambio de vivienda. Al utilizar nuestros servicios, acepta estos términos en su totalidad.",
    "eligibility": {
      "title": "1. Elegibilidad y registro",
      "text": "El acceso al club DONKEY TRAVEL está estrictamente reservado a los anfitriones con un anuncio activo en plataformas reconocidas (como Airbnb) con una calificación global mínima de 4,5 sobre 5. Cualquier falsificación de estos criterios dará lugar a la eliminación inmediata de la cuenta sin reembolso de la suscripción."
    },
    "subscription": {
      "title": "2. Suscripción y Pagos",
      "text": "El uso completo de la plataforma requiere la suscripción a uno de nuestros paquetes (Mensual, Anual o Club+). Los pagos son seguros y procesados ​​por proveedores externos. La suscripción es tácitamente renovable salvo cancelación por parte del usuario."
    },
    "exchanges": {
      "title": "3. Cómo funcionan los intercambios",
      "text": "Los intercambios dentro del club se basan en la confianza y el respeto mutuo. Los acuerdos de intercambio se realizan directamente entre los miembros a través de nuestra mensajería interna. Se celebra entre ambas partes un contrato de intercambio moral y, en su caso, jurídico."
    },
    "responsibilities": {
      "title": "4. Compromisos y Responsabilidades",
      "text": "Cada miembro se compromete a presentar su alojamiento de forma transparente, con fotografías recientes y descripciones precisas. El miembro anfitrión vela por la impecable higiene del lugar. El miembro visitante se compromete a respetar escrupulosamente el alojamiento y su normativa interna. DONKEY TRAVEL actúa como facilitador y no es parte en los contratos de intercambio entre miembros. No asumimos ninguna responsabilidad por daños, disputas o cancelaciones de última hora, aunque podemos intervenir en la mediación."
    },
    "termination": {
      "title": "5. Suspensión y Terminación",
      "text": "DONKEY TRAVEL se reserva el derecho de suspender o banear a cualquier miembro que no respete las reglas de buena conducta de la comunidad, acumule malos comentarios o viole estas condiciones, unilateralmente."
    },
    "contact": {
      "title": "6. Ley aplicable y disputas",
      "text": "Estas condiciones se rigen por la ley francesa. En caso de desacuerdo, las partes se comprometen a buscar una solución amistosa antes de cualquier acción judicial ante los tribunales competentes. Para cualquier pregunta, contáctenos a legal@donkey.travel."
    }
  }
};
